import React from 'react';

const ChevronDown = ({ className }: { className?: string }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 12.585 7.543"
			className={className}
		>
			<path
				fill="none"
				stroke="#141b4d"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="2.5"
				d="m1.768 1.768 4.525 4.525 4.52-4.525"
			/>
		</svg>
	);
};

export default ChevronDown;
